import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import { Archive, ArchiveRestore, Star, X } from "lucide-react";
import React from "react";

export interface BulkActionBarProps {
  selectedCount: number;
  onBulkStar?: () => void;
  onBulkArchive?: () => void;
  onClearSelection?: () => void;
  selectedItemsStarred?: "all" | "none" | "mixed";
  selectedItemsArchived?: "all" | "none" | "mixed";
  className?: string;
}

export const BulkActionBar: React.FC<BulkActionBarProps> = ({
  selectedCount,
  onBulkStar,
  onBulkArchive,
  onClearSelection,
  selectedItemsStarred = "none",
  selectedItemsArchived = "none",
  className,
}) => {
  if (selectedCount === 0) {
    return null;
  }

  return (
    <div className={cn("flex items-center gap-1", className)}>
      <TooltipProvider>
        {onBulkStar && (
          <Tooltip>
            <TooltipTrigger asChild>
              <button
                onClick={onBulkStar}
                className={cn(
                  "flex items-center justify-center w-8 h-8 hover:bg-neutral-100 dark:hover:bg-neutral-800 rounded-md transition-colors cursor-pointer",
                  selectedItemsStarred === "all"
                    ? "text-gold"
                    : "text-neutral-700 dark:text-neutral-300",
                )}
              >
                <Star
                  className={cn(
                    "w-4 h-4",
                    selectedItemsStarred === "all" && "fill-current",
                  )}
                />
              </button>
            </TooltipTrigger>
            <TooltipContent>
              <p>
                {selectedItemsStarred === "all"
                  ? "Unstar selected items"
                  : selectedItemsStarred === "mixed"
                    ? "Star unstarred items"
                    : "Star selected items"}
              </p>
            </TooltipContent>
          </Tooltip>
        )}

        {onBulkArchive && (
          <Tooltip>
            <TooltipTrigger asChild>
              <button
                onClick={onBulkArchive}
                className="flex items-center justify-center w-8 h-8 text-neutral-700 dark:text-neutral-300 hover:bg-neutral-100 dark:hover:bg-neutral-800 rounded-md transition-colors cursor-pointer"
              >
                {selectedItemsArchived === "all" ? (
                  <ArchiveRestore className="w-4 h-4" />
                ) : (
                  <Archive className="w-4 h-4" />
                )}
              </button>
            </TooltipTrigger>
            <TooltipContent>
              <p>
                {selectedItemsArchived === "all"
                  ? "Unarchive selected items"
                  : selectedItemsArchived === "mixed"
                    ? "Archive unarchived items"
                    : "Archive selected items"}
              </p>
            </TooltipContent>
          </Tooltip>
        )}

        {onClearSelection && (
          <Tooltip>
            <TooltipTrigger asChild>
              <button
                onClick={onClearSelection}
                className="flex items-center justify-center w-8 h-8 text-neutral-700 dark:text-neutral-300 hover:bg-neutral-100 dark:hover:bg-neutral-800 rounded-md transition-colors cursor-pointer"
              >
                <X className="w-4 h-4" />
              </button>
            </TooltipTrigger>
            <TooltipContent>
              <p>Clear selection</p>
            </TooltipContent>
          </Tooltip>
        )}
      </TooltipProvider>
    </div>
  );
};
